import type { ConsentChoice } from '@/js/lib/analytics';
import {
  CONSENT_ACCEPTED,
  CONSENT_REJECTED,
  persistConsent,
  readConsent,
} from '@/js/lib/analytics';

const SELECTOR_BANNER = '.js-cookie-consent';
const SELECTOR_ACCEPT = '.js-cookie-consent-accept';
const SELECTOR_REJECT = '.js-cookie-consent-reject';

function closeBanner(banner: HTMLElement, choice: ConsentChoice): void {
  banner.hidden = true;
  persistConsent(choice);
}

export function initCookieConsent(): void {
  const banner = document.querySelector<HTMLElement>(SELECTOR_BANNER);
  if (!banner) {
    return;
  }

  if (readConsent() !== 'unset') {
    return;
  }

  banner.hidden = false;

  banner.querySelector<HTMLButtonElement>(SELECTOR_ACCEPT)?.addEventListener('click', () => {
    closeBanner(banner, CONSENT_ACCEPTED);
  });

  banner.querySelector<HTMLButtonElement>(SELECTOR_REJECT)?.addEventListener('click', () => {
    closeBanner(banner, CONSENT_REJECTED);
  });
}
